import { render, staticRenderFns } from "./CuratedSearchRow.vue?vue&type=template&id=19420d42&scoped=true"
import script from "./CuratedSearchRow.vue?vue&type=script&lang=js"
export * from "./CuratedSearchRow.vue?vue&type=script&lang=js"
import style0 from "./CuratedSearchRow.vue?vue&type=style&index=0&id=19420d42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19420d42",
  null
  
)

export default component.exports